module.exports = __webpack_public_path__ + "static/img/cta-bg.598bd60.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/backgrounds/cta-bg.jpg
// module id = zy7E
// module chunks = 1